<template>
  <div class="table">
    <div ref="caozuo" class="headerCaozuo">
      <div>
        <el-button size="small" plain @click="shuaxin">
          <i class="el-icon-refresh-right"></i> 刷新
        </el-button>
        <el-button size="small" @click="handleAdd">
          <i class="el-icon-plus"></i> 新增
        </el-button>
        <el-button size="small" @click="handleDaoru">
          <i class="el-icon-download"></i> 导入手机号
        </el-button>
      </div>
      <div>
        <!-- //搜索 -->
        <el-form :model="formes" :inline="true" label-width="90px">
          <el-form-item label style="margin-bottom: 0">
            <el-select
              v-model="select"
              placeholder="请选择"
              @click="switchover"
              size="small"
              class="especially"
              style="width: 110px"
            >
              <el-option label="手机号码" :value="1"></el-option>
              <!-- <el-option label="用户类型" :value="2"></el-option>
              <el-option label="账号状态" :value="3"></el-option> -->
            </el-select>
            <el-input
              v-if="select == 1"
              @input="searchArr"
              size="small"
              placeholder="请输入手机号码"
              v-model="formes.mobile"
              class="especially2"
              style="width: 160px"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <!-- <el-select
              v-if="select == 2"
              v-model="formes.type"
              placeholder="请选择用户类型"
              filterable
              size="small"
              class="especially2"
              style="width: 160px"
            >
              <el-option label="电销卡" :value="1"></el-option>
            </el-select>
            <el-select
              v-if="select == 3"
              v-model="formes.user_id"
              placeholder="请选择账号状态"
              filterable
              size="small"
              class="especially2"
              style="width: 160px"
            >
              <el-option label="启用" :value="1"></el-option>
            </el-select> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      ref="multipleTable"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column label="手机号码">
        <template slot-scope="scope">
          {{ scope.row.UserInfo.mobile }}
        </template>
      </el-table-column>
      <el-table-column label="用户类型">
        <template slot-scope="scope">
          <span>{{ calltype(scope.row.UserInfo.call_type_id) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账号状态">
        <template slot-scope="scope">
          <span :class="[scope.row.UserInfo.status == 1 ? 'qing' : 'jing']">{{
            scope.row.UserInfo.status == 1 ? "启用" : "禁用"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="录音状态">
        <template slot-scope="scope">
          <span
            :class="[
              scope.row.UserInfo.is_open_recording == 1 ? 'qing' : 'jing',
            ]"
          >
            {{ scope.row.UserInfo.is_open_recording == 0 ? "关闭" : "开启" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="app_expiration_time"
        label="APP授权到期时间"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" plain @click="deletes(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="pagination_bottom"
      background
      layout="total,sizes, prev, pager, next"
      :page-sizes="[20, 50, 100, 200, 300, 400]"
      @size-change="handleSizeChange"
      :total="total"
      :page-size="pagesize"
      @current-change="current_change"
      :current-page="currentPage"
    ></el-pagination>
    <AddMNinformation
      v-if="modalVisible == 'add'"
      :isShow="modalVisible == 'add'"
      :company_id="company_id"
      @close="modalVisible = null"
    ></AddMNinformation>
    <DaoruNumber
      v-if="modalVisible == 'daoru'"
      :isShow="modalVisible == 'daoru'"
      :company_id="company_id"
      @close="modalVisible = null"
    ></DaoruNumber>
  </div>
</template>

<script>
import { getData } from "@/api/index";
import DaoruNumber from "./components/DaoruNumber";
import AddMNinformation from "./components/AddMNinformation";

export default {
  props: {
    company_id: Number,
  },
  components: {
    DaoruNumber,
    AddMNinformation,
  },
  data() {
    return {
      select: 1,
      zhanshi: "800px",
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 20, //每页的数据条数
      currentPage: 1, //默认开始页面
      form: {},
      fileList: [],
      formes: {
        mobile: "",
        pagesize: 20,
        page: 1,
      },
      callTypeArr: [],
      modalVisible: null,
    };
  },
  created() {
    this.getMainData();
    this.getCallSeat();
  },
  mounted() {
    setTimeout(() => {
      var caozuo = this.$refs.caozuo.offsetHeight;
      var H = document.body.clientHeight;
      this.zhanshi = H - caozuo - 270;
    }, 100);
    const that = this;
    window.onresize = () => {
      var caozuo = this.$refs.caozuo.offsetHeight;
      var H = document.body.clientHeight;
      that.zhanshi = H - caozuo - 270;
    };
  },
  methods: {
    handleAdd() {
      this.modalVisible = "add";
    },
    handleDaoru() {
      this.modalVisible = "daoru";
    },
    calltype(val) {
      for (let i of this.callTypeArr) {
        if (i.call_type_id == val) return i.callTypeInfo.card;
      }
    },
    getCallSeat() {
      getData("call.CallSeatController/listAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.callTypeArr = res.data;
      });
    },
    switchover() {
      this.formes = {
        user_id: "",
        type: "",
      };
      this.currentPage = 1;
      this.getMainData();
    },
    shuaxin() {
      this.currentPage = 1;
      this.getMainData();
      this.$message({ message: "刷新成功", type: "success" });
    },
    searchArr() {
      let params = {
        pagesize: 20,
        page: 1,
        company_id: this.company_id,
      };
      if (this.formes.mobile) {
        params.mobile = this.formes.mobile;
      }
      getData("company.CompanyUserController/mobilePageAction", params).then(
        (res) => {
          if (res.code !== 200) return this.$message.error(res.message);
          this.tableData = res.data.data || [];
          this.total = res.data.total || 0;
        }
      );
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
    // 获取数据
    getMainData() {
      getData("company.CompanyUserController/mobilePageAction", {
        page: this.currentPage,
        pagesize: this.pagesize,
        company_id: this.company_id,
      }).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.tableData = res.data.data || [];
        this.total = res.data.total || 0;
      });
    },
    // 删除
    deletes(e) {
      this.$confirm("是否要删除该数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getData("company.CompanyUserController/mobileDelAction", {
            id: e.id,
            company_id: this.company_id,
          }).then((res) => {
            if (res.code !== 200) return this.$message.error(res.message);
            this.$message({ message: "删除成功", type: "success" });
            this.getMainData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    handleSizeChange(val) {
      this.pagesize = val;
      this.getMainData();
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getMainData();
    },
  },
};
</script>

<style lang="less" scoped>
.el-tabs--border-card {
  border: 0;
  box-shadow: none;
}
.avatar-uploader {
  display: none;
}
.content {
  height: 300px;
  overflow: hidden;
  /deep/img {
    width: 360px;
  }
}
.content:hover {
  overflow-y: overlay;
}
::-webkit-scrollbar {
  width: 0px !important;
  height: 0px !important;
  // width: 18px !important;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgb(182, 182, 182);
  box-shadow: inset 0 0 5px rgb(182, 182, 182);
  border: 7px solid transparent;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
  box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0);
}
</style>
<style lang="less" scoped>
.especially /deep/.el-input__inner {
  border-radius: 5px 0 0 5px;
  border-right: 0;
}
.especially2 /deep/.el-input__inner {
  border-radius: 0 5px 5px 0;
  border-left: 0;
}
.especially /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-right: 0;
}
.especially2 /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-left: 0;
}
.el-container {
  display: flex;
  flex-direction: column;
}
.qing {
  color: #46c160;
}
.jing {
  color: #ec5952;
}
</style>
<style src="@/assets/css/index.css" scoped></style>
<style lang="less" src="@/assets/css/comparison.less" scoped></style>
